module.exports = __webpack_public_path__ + "img/Skip bins.8b3397f9.svg";